import { motion } from "framer-motion";

const navigation = [
  { name: "About", url: "/#about" },
  { name: "Experience", url: "/#experience" },
  { name: "Projects", url: "/#projects" },
  { name: "Contact", url: "#contact" },
];

const socials = [
  { name: "GitHub", url: "https://github.com/cherubinifranco" },
  { name: "LinkedIn", url: "https://www.linkedin.com/in/cherubinifranco/" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/[0.08] bg-[#010710] text-white">
      <div className="relative mx-auto max-w-6xl px-6">
        <div className="grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr] lg:py-20">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <a href="/" className="group inline-flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-white/[0.04] ring-1 ring-white/10 transition group-hover:ring-white/20">
                <img
                  src="../assets/logo.png"
                  alt=""
                  className="h-7 w-7 object-contain"
                />
              </div>

              <div>
                <p className="text-sm font-medium tracking-tight text-white">
                  Cherubini Franco
                </p>
                <p className="mt-1 text-xs text-white/35">Software Developer</p>
              </div>
            </a>

            <p className="mt-6 max-w-sm text-sm leading-6 text-white/40">
              Building thoughtful digital experiences with clean code,
              curiosity, and an unhealthy attention to detail.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <p className="mb-5 text-[11px] font-medium uppercase tracking-[0.2em] text-white/25">
              Explore
            </p>

            <div className="flex flex-col items-start gap-3">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.url}
                  className="group flex items-center gap-2 text-sm text-white/45 transition hover:text-white"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="mb-5 text-[11px] font-medium uppercase tracking-[0.2em] text-white/25">
              Connect
            </p>

            <div className="flex flex-col items-start gap-3">
              {socials.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  className="group flex items-center gap-2 text-sm text-white/45 transition hover:text-white"
                >
                  {social.name}
                  <span className="text-white/20 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5">
                    ↗
                  </span>
                </a>
              ))}

              <a
                href="mailto:cherubini.franco@hotmail.com"
                className="group mt-1 flex items-center gap-2 text-sm text-white/45 transition hover:text-white"
              >
                Email me
                <span className="text-white/20 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5">
                  ↗
                </span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </footer>
  );
}
